import { Flex, Spin } from 'antd';
import { ErrorListDisplay } from 'components/ErrorDisplay';
import { Title } from 'components/mvp-typography';
import { useAuth } from 'features/auth/auth-action-sign-in-out';
import {
  CoreSignupForm,
  SignupFormProps
} from 'features/sign-in/v2/_components/form-signup';
import { useUserRegistrationMutation } from 'lib/hooks/tanstack/useUserRegistrationMutation';
import { useQueryErrorNotifier } from 'lib/hooks/use-query-error-notifier';
import { useErrorList } from 'lib/utils/useErrorList';
import { useDispatch } from 'react-redux';

interface UserRegistrationFormPageProps {
  onSubmit?: () => void;
}

export default function UserRegistrationFormPage(
  props: UserRegistrationFormPageProps
) {
  const dispatch = useDispatch();
  const auth = useAuth(dispatch);
  const errorList = useErrorList();
  const registrationMutation = useUserRegistrationMutation();

  useQueryErrorNotifier(registrationMutation, errorList, 'User Registration');
  useQueryErrorNotifier(auth.signIn, errorList, 'Sign In');

  async function handleFormFinish(values: SignupFormProps) {
    const { name, email, password } = values;
    // Create the account
    await registrationMutation.mutateAsync({
      displayName: name,
      email,
      password
    });

    // Sign in with the credentials
    await auth.signIn.mutateAsync({ email, password });
    props.onSubmit?.();
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px'
      }}
    >
      <Flex vertical gap={16}>
        <div>
          <Title>Create your account</Title>
        </div>
        <ErrorListDisplay errorList={errorList} />
        {!auth.signIn.isPending && !registrationMutation.isPending ? (
          <CoreSignupForm
            onFinish={handleFormFinish}
            clinicNameRequired={false}
            hideLogo
            disabled={{
              clinicName: false,
              name: registrationMutation.isLoading,
              email: registrationMutation.isLoading,
              password: registrationMutation.isLoading
            }}
          />
        ) : (
          <Spin />
        )}
      </Flex>
    </div>
  );
}
